module.exports = __webpack_public_path__ + "static/media/16UNODC39.477747d7.jpg";